export default __webpack_public_path__ + "static/media/pptx.a8db24a1.svg";